(function ($, undefined) {
    'use strict';

    $('.btn--submit-once').on('click', function (e) {
        var $btn = $(this);

        if ($btn.attr('data-clicked')) {
            e.preventDefault();
        }

        $btn.attr('data-clicked', 'clicked');
    });
})(jQuery);
